import {defineAsyncComponent} from "vue";
import {Model} from "@/services/api";
import {arrayJoin} from "@/helpers/utils";

export default class Person extends Model {
    static relations = {
        events: require("@/services/models/lafil013").default,
        inventories: require("@/services/models/inventory").default,
        inventories_authors: require("@/services/models/inventory").default,
    };

    toString() {
        return arrayJoin([this.last_name, this.first_name]);
    }

    static route() {
        return 'persons';
    }

    detail() {
        return {
            title: this,
            component: defineAsyncComponent(() => import('@/components/persons/person-details.vue')),
            props: {person: this}
        };
    }
}
